import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Box, Text, Paragraph, Button/*, Anchor, TextInput*/ } from 'grommet';
import { withRouter } from 'react-router-dom';
import { ValidateOldCellNumberCtrl } from "../Controllers/Account/ValidateOldCellNumberCtrl";
import ModalErrorTimeout from './ModalErrorTimeout';
import { loader } from '../Utils/Utility';

class ModifyTelephoneStep1 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            next: this.props.values.dataOldTel,
            dataOldTel:'',
            showTimeoutModal: false,
            loading: false
        }

        this.hideNumber = this.hideNumber.bind(this);
    }
    componentWillReceiveProps(newProps) {
        if (newProps !== newProps.values.dataOldTel)
            this.setState({
                next: newProps
            })
    }

    sendOldNumberOTP = () => {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        self.setState({loading: true});
        ValidateOldCellNumberCtrl(function (data) {
            self.setState({
                dataOldTel: data === undefined ? {} : data,
                loading: false
            } , function(){ 
                if( self.state.dataOldTel === true){
                    self.saveAndContinue();
                }
        })
        }, function (error) {
            self.setState({
                status: error,
                loading: false
            }, function(){
                if(self.state.status === 500 || self.state.status === 400 || self.state.status === 404 || self.state.status === 403){
                    self.props.history.push({
                        pathname: '/ErrorPage',
                        state: self.state
                    })  
                } else if (self.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // self.props.history.push({
                    // pathname: '/login'
                    // })
                }
            })

        }, token, ids)
    }

    saveAndContinue = () => {
        this.props.nextStep();
    }

    hideNumber(number) {
        var num = "+" + number.substring(1, number.length - 2).replace(new RegExp("[0-9]", "g"), '*') + '' + number.substring(number.length - 2, number.length)
        return num;
    }


    render() {
        
        return (

            <Box className='contentbox'>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box direction="column" align='center'>
                    <Box direction='row'>
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Modifica telefono cellulare</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box style={{ height: '280px' }}>
                        <Box direction='row'>
                            <Paragraph className='textParagraph'>Invieremo <span className='bold'>il codice OTP </span>al tuo <span className='bold'>vecchio numero di cellulare</span></Paragraph>
                        </Box>
                        <Box direction='column' margin='small'>
                            <Box direction='row' gap='small' justify='center'>
                                <Text className='telnumber'>{this.props.values.telephone}</Text>
                            </Box>
                        </Box>
                    </Box>
                    <Box className='informativa' justify='center' direction='row'>
                        <Button className='btnform' style={{ width: '170px' }} onClick={this.sendOldNumberOTP}>AVANTI</Button>
                    </Box>
                    {this.state.loading ? loader : ''}
                </Box>
            </Box>


        )
    }
}

export default ModifyTelephoneStep1 = withRouter(ModifyTelephoneStep1);
